package com.trevorwiebe.timesheet.mileage.presentation

import com.trevorwiebe.timesheet.mileage.domain.model.TripType
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

@OptIn(ExperimentalTime::class)
data class AddMileageFormState(
    val date: LocalDateTime = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault()),
    val showDatePicker: Boolean = false,
    val selectedEmployeeId: String = "",
    val selectedEquipmentId: String = "",
    val selectedTrailerId: String? = null,
    val mileageText: String = "",
    val selectedTripTypeOption: TripTypeOption = TripTypeOption.LOADING,
    // STATE_LINE
    val fromState: String = "",
    val toState: String = "",
    val highwayText: String = "",
    // FUEL
    val gallonsText: String = "",
    // FUEL / LOADING / UNLOADING (shared location picker)
    val selectedLocationId: String = "",
    val isNewLocation: Boolean = false,
    val newLocationName: String = "",
    val newLocationCity: String = "",
    val newLocationState: String = "",
    // SERVICE
    val serviceLocationText: String = "",
    // START_END
    val startEndLocationText: String = "",
    // OTHER
    val otherNotesText: String = "",
    // LOADING / UNLOADING
    val loadingUnloadingNotesText: String = "",
    // validation
    val equipmentError: String? = null,
    val fromStateError: String? = null,
    val toStateError: String? = null,
    val locationError: String? = null,
    val serviceLocationError: String? = null,
    val receiptError: String? = null
) {
    val selectedTripType: TripType get() = selectedTripTypeOption.tripType
}
